import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class FloatingInfoService {
  currentInformation: Subject<string[]> = new Subject<string[]>();
  infoShowing: Subject<boolean> = new BehaviorSubject<boolean>(false);
  newPosition: Subject<{ x: number; y: number }> = new Subject<{
    x: number;
    y: number;
  }>();

  showInfo(data: string[]) {
    this.currentInformation.next(data);
    this.infoShowing.next(true);
  }

  updatePosition(pos: any) {
    this.newPosition.next(pos);
  }

  hideInfo() {
    this.infoShowing.next(false);
  }
}
